import request from '@/utils/request'
const proxyN = serviceURL
/* 监视监控 */
export function getMonitorList(query) {
  return request({
    url: proxyN + 'business/multipleServer/multipleTableServer?serviceID=GetMsgs',
    method: 'get',
    params: query
  })
}
/* 监视监控--去重 */
export function getMonitorDisList(query) {
  return request({
    url: proxyN + 'business/multipleServer/multipleTableServer?serviceID=GetMsgsDistinct',
    method: 'get',
    params: query
  })
}
/* 数据告警 */
export function getVedioList(query) {
  return request({
    url: proxyN + 'business/multipleServer/multipleTableServer?serviceID=GetGuardVoice',
    method: 'get',
    params: query
  })
}
/* 数据审核 同监视监控来源*/
export function getCheckList(query) {
  return request({
    //url: proxyN + 'business/multipleServer/multipleTableServer?serviceID=GetMsgs', 
    url: proxyN + 'business/multipleServer/multipleTableServer?serviceID=GetMsgsLists', 
    method: 'get',
    params: query
  })
}
/* 数据审核 同监视监控来源*/
export function getCheckSta(query) {
  return request({
    //url: proxyN + 'business/multipleServer/multipleTableServer?serviceID=GetMsgs', 
    url: proxyN + 'business/multipleServer/multipleTableServer?serviceID=GetMsgsSta', 
    method: 'get',
    params: query
  })
}
/* 数据审核 获得报文信息（测站编码 报文模板 报文时间）*/
export function GetMsgsByParamters(query) {
  return request({
    //url: proxyN + 'business/multipleServer/multipleTableServer?serviceID=GetMsgs', 
    url: proxyN + 'business/multipleServer/multipleTableServer?serviceID=GetMsgsByParamters', 
    method: 'get',
    params: query
  })
}

/* 数据审核 逻辑删除报文信息 （测站编码 报文模板 报文时间）*/
export function deleteRgbxByParamters(query) {
  return request({
    //url: proxyN + 'business/multipleServer/multipleTableServer?serviceID=GetMsgs', 
    url: proxyN + 'business/multipleServer/multipleTableServer?serviceID=DeleteRgbxByParamters', 
    method: 'get',
    params: query
  })
}


/* 数据审核  任务树  */
export function getMarkDataList(query) {
  return request({
    // url: proxyN + 'business/multipleServer/multipleTableServer?serviceID=GetTemplateList ',
    url: proxyN + 'business/multipleServer/multipleTableServer?serviceID=GetRgbxGrop',
    method: 'get',
    params: query
  })
}
// /* 数据审核  任务树  */
// export function GetRgbxGrop(query) {
//   return request({
//     url: proxyN + '/business/multipleServer/multipleTableServer?serviceID=GetRgbxGrop ',
//     method: 'get',
//     params: query
//   })
// }
/*   添加报文信息  */
export function createRGBX(query) {
  return request({
    url: proxyN + 'business/singleEditServer/singleAdd?serviceID=RgbxMsg',
    method: 'get',
    params: query
  })
}
/* 数据审核  修改报文信息  */
export function updateRGBX(query) {
  return request({
    url: proxyN + 'business/singleEditServer/singleUpdate?serviceID=RgbxMsg',
    method: 'get',
    params: query
  })
}

/* 后台审批 */
export function updateRGBXB(query) {
  return request({
    // url: proxyN + 'business/multipleServer/multipleTableServer?serviceID=AppUserExammines  ',
    url: jsvaIPIURL + 'rgxb/examineap',
    method: 'post',
    params: query
  })
}

/* 数据审核  删除报文信息  */
export function deleteRGBX(query) {
  return request({
    url: proxyN + 'business/singleEditServer/singleDel?serviceID=RgbxMsg',
    method: 'get',
    params: query
  })
}
/* 删除400天前的历史数据  */
export function clearRGBX(query) {
  return request({
    url: proxyN + 'Auditing/GetUserList',
    //url: proxyN + 'business/singleEditServer/singleDel?serviceID=RgbxMsg',
    method: 'get',
    params: query
  })
}

/* 报文历史 */
export function getPacketList(query) {
  return request({
    url: proxyN + 'business/multipleServer/multipleTableServer?serviceID=ExcelMsgs',
    method: 'get',
    params: query
  })
}
export function fetchList(query) {
  return request({
    url: proxyN + 'Auditing/GetUserList',
    method: 'get',
    params: query
  })
}
export function createInfo(data) {
  return request({
    url: proxyN + 'Auditing/AddUser',
    method: 'post',
    data
  })
}

export function updateInfo(data) {
  return request({
    url: proxyN + 'Auditing/UpdateUser',
    method: 'post',
    data
  })
}

/* 删除多个  */
export function deleteList(query) {
  return request({
    url: proxyN + 'Auditing/DeleteUserList',
    method: 'post',
    data: query
  })
}




/* 获取统计信息 */
export function getStatistic(query) {
  return request({
    url: proxyN + 'business/multipleServer/multipleTableServer?serviceID=GetStatistic',
    method: 'get',
    params: query
  })
}

/* 获取水位流量过程线查询--河道站 */
export function getRivers(query) {
  return request({
    url: proxyN + 'business/multipleServer/multipleTableServer?serviceID=GetRivers',
    method: 'get',
    params: query
  })
}

/* 获取水位流量过程线查询(蓄水量)--水库站 */
export function getRsvrs(query) {
  return request({
    url: proxyN + 'business/multipleServer/multipleTableServer?serviceID=GetRsvrs',
    method: 'get',
    params: query
  })
}

/* 获取气温过程线图 */
export function getTmps(query) {
  return request({
    url: proxyN + 'business/multipleServer/multipleTableServer?serviceID=GetTmps',
    method: 'get',
    params: query
  })
}


/* 获取降雨过程线图 */
export function getRains(query) {
  return request({
    url: proxyN + 'business/multipleServer/multipleTableServer?serviceID=GetRains',
    method: 'get',
    params: query
  })
}

